"use client";
import { useState } from "react";
import Stepper from "@/components/stepper/Stepper";
import StepperControl from "@/components/stepper/StepperControl";
import { UseContextProvider } from "@/components/stepper/StepperContext";

import Account from "@/components/stepper/steps/Account";
import Details from "@/components/stepper/steps/Details";
import Final from "@/components/stepper/steps/Final";
import Navbar from "@/components/navbar";
import { cn } from "@/lib/utils";
import Loading from "@/components/loading";
import Pattern02 from "@/components/patterns/pattern02";
import { useStepperContext } from "../../../components/stepper/StepperContext";
import { useSelector } from "react-redux";

function Page() {
  const { userData, setUserData } = useStepperContext();
  const [currentStep, setCurrentStep] = useState(1);

  const steps = ["Details", "Job Info", "Resume"];

  const displayStep = (step) => {
    switch (step) {
      case 1:
        return <Account />;
      case 2:
        return <Details />;
      case 3:
        return <Final />;
      default:
    }
  };
  // function for handling next buttons logic
  const handleClick = (direction) => {
    let newStep = currentStep;

    direction === "next" ? newStep++ : newStep--;
    // check if steps are within bounds
    newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
  };

  return (
    <>
      <Navbar />
      {/* Banner */}
      <main className="w-full h-auto min-h-screen">
        <div
          className={cn(
            "relative pb-32 bg-palette-neutral-1 p-4 sm:p-10 md:p-20 min-h-screen",
            "flex flex-col justify-center items-start",
          )}>
          <h1 className="text-4xl md:text-5xl lg:text-7xl max-w-5xl text-start mt-10 text-palette-neutral-4">
            Accelerate Your Developer Journey with Elite Global Opportunities
          </h1>
          <p className="text-xl md:text-lg text-start text-palette-neutral-4 mt-4 md:mt-10 max-w-6xl">
            Thrive in a world of remote work, blending the autonomy of
            freelancing with the consistency of full-time engagement. Choose
            from a curated selection of innovative projects with leading clients
            worldwide.
          </p>

          <Loading
            className1="absolute-center z-10 hidden md:block bg-palette-neutral-3"
            className2="bg-palette-dark-1"
            direction="y"
            style={{ top: "85%", height: 150 }}
          />
          <Pattern02 className="absolute right-10 top-[50%] hidden md:grid" />
        </div>
      </main>
{/* freelancer form  */}
      <div className="bg-palette-dark-2 py-10">
        <div className="mx-auto rounded-2xl bg-white pb-2 shadow-xl md:w-1/2 p-0">
          {/* Stepper */}
          <div className="horizontal container mt-5">
            <Stepper steps={steps} currentStep={currentStep} />

            <div className="my-10 p-10 ">
              <UseContextProvider>
                {displayStep(currentStep)}
              </UseContextProvider>
            </div>
          </div>

          {/* navigation button */}

          <StepperControl
            handleClick={handleClick}
            currentStep={currentStep}
            steps={steps}
          />
        </div>
      </div>
    </>
  );
}

export default Page;
